export default function PostVisitNotes({ value, onChange }) {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h2 className="text-xl font-bold text-[#04395b] mb-2">Post-Visit Notes</h2>
      <div className="text-gray-700 text-sm mb-2">Enter doctor's advice, medication, dietary changes, etc.</div>
      <textarea
      className="w-full border rounded p-2"
      placeholder="Type your notes here!"
      rows={4}
      onChange={(e) => onChange(e.target.value)}
      value={value}
    />
    </div>
  );
}
